import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../Input/Textarea";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface PopupTemplateDeleteModalProps extends DefaultModalCommonProps {
  templateId: number;
}

export default function PopupTemplateDeleteModal({
  closeEvent,
  confirmEvent,
  templateId,
}: PopupTemplateDeleteModalProps) {
  const [reason, setReason] = useState("");
  const [deleteTemplate, setDeleteTemplate] = useState(false);

  // 팝업 템플릿 삭제
  const { response, error, loading } = useApi({
    method: "delete",
    url:
      deleteTemplate && templateId > -1
        ? `popup/message/${templateId}`
        : undefined,
    data: {
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      toast.success("팝업 템플릿이 삭제되었습니다.");
      closeEvent();
      if (confirmEvent) {
        confirmEvent();
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "팝업 템플릿 삭제에 실패하였습니다.");
    }
  }, [error]);

  return (
    <DefaultModalLayout
      modalTitle={"팝업 템플릿 삭제"}
      closeEvent={closeEvent}
      confirmEvent={() => setDeleteTemplate(true)}
      isDeleteModal={true}
      isSmallModal={true}
    >
      <>
        <ModalLabel>삭제 사유</ModalLabel>

        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="삭제 사유 직접 입력 (100글자 이내)"
        />

        {loading && <Loader />}
      </>
    </DefaultModalLayout>
  );
}
